import {Component} from 'san';

import styles from './style/index.module.less';

export default class RecentArticle extends Component {
    static template = require('./index.html');
    initData() {
        return {
            styles
        };
    }
    attached() {
        this.storeDispatch('recentArticle:showLog');
    }
    clickHandler(event, index) {
        this.storeDispatch('recentArticle:clkLog', {pos: index});
    }
};
